import React, { useContext, useState, useEffect, useRef } from "react";
import { Button, Col, Form, Table, Row } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import schoolApi from "../../api/schoolApi";
import Card from "react-bootstrap/Card";

import html2pdf from "html2pdf.js";
import { Helmet } from "react-helmet";
import "react-toastify/dist/ReactToastify.css";
import { FiDownload } from "react-icons/fi";
import { useOutletContext } from "react-router-dom";

import FeeReceipt from "./feerecipt";
import { SessionContext } from "../SessionProvider";

const FeeDepositeEdit = (props) => {
  console.log("props@@=>", props);
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);
  
  const location = useLocation();
  console.log("location-->", location);
  const navigate = useNavigate();
  const [studentRecord, SetStudentRecord] = useState();
  const [settings, setSettings] = useState([]);
  const [frequency, setFrequency] = useState(3);
  const [studentInstallment, setStudentInstallment] = useState([]);
  const [tempAmount, setTempAmount] = useState({});
  const [receiptData, setreceiptData] = useState({});

  const [openItem, setOpenItem] = useState(null);
  const [selectedStudent, setStudent] = useOutletContext();
  const toggleDetails = (id) => {
    setOpenItem(openItem === id ? null : id);
  };
  console.log("studentRecord-->", studentRecord);
  const receiptRef = useRef();
  useEffect(() => {
    async function initClass() {
      try {
      let arrInstallments = [];
      if (selectedStudent) {
        console.log("selectedStudent", selectedStudent);
        const studentDetails = await schoolApi.fetchStudentsById(selectedStudent.id, selectedSessionId);
        console.log("studentDetails for session (Slips) == ", studentDetails);

        const feeInstallments = await schoolApi.getStudentFeeIntsallmentRecords(
           studentDetails?.studentRec?.student_addmission_id,
           selectedSessionId
        );

        if (feeInstallments?.success) {
        arrInstallments.push(feeInstallments);
        console.log("feeInstallments-->", feeInstallments);
        console.log("arrInstallments@@@=>", arrInstallments);
        const filteredInstallements = arrInstallments[0]?.result?.filter(
          (res) => res.deposited_amount !== null && res.deposited_amount !== 0
        );
        console.log("filteredInstallements@!!@=>", filteredInstallements);
        
          console.log("hhdjsk");

          setStudentInstallment(filteredInstallements);
        } else {
          setStudentInstallment([]);
        }
      }
    } catch (error) {
      setStudentInstallment([]);
    }
    }
    initClass();
  }, [selectedStudent, selectedSessionId]);
  console.log("studentInstallment ->", studentInstallment);


  const handleDownloadReceipt = async (res) => {
    setreceiptData(res);
    console.log("receiptData ->", res);

    // Delay to ensure the component has re-rendered with the new receiptData
    setTimeout(() => {
      const element = receiptRef.current;
      if (!element) {
        console.error("Receipt element not found");
        return;
      }

      const options = {
        margin: [0.5, 0.5, 0.5, 0.5],
        filename: "Fee Receipt.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 3, useCORS: true },
        jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
      };

      html2pdf()
        .set(options)
        .from(element)
        .save()
        .then(() => {
          setreceiptData({});
          console.log("PDF saved and receiptData cleared.");
        })
        .catch((error) => {
          console.error("Error generating PDF:", error);
        });
    }, 500); // Adjust the delay as needed
  };

  return (
    <>
      <Helmet>
        {" "}
        <title>{props?.tabName}</title>{" "}
      </Helmet>
      <Row>
        <Col>
          <Card className="mt-4 mx-4">
            <Card.Body className="card-header">
              <Card.Title className="text-center">Fee Details</Card.Title>
            </Card.Body>
          </Card>

          {studentInstallment?.length > 0 ? (
            studentInstallment?.map((res) => {
              console.log("ress=>", res);
              return (
                <Card key={res?.id} className="mt-2 mx-4">
                  <Card.Body>
                  
                    <div className="d-flex align-items-center justify-content-between ">
                      <div>
                        <span className="span-title">
                          {res.month} Month Fees
                        </span>

                        <span>
                          <h5 className="heading-title mt-3">
                            ₹ {res.deposited_amount}
                          </h5>
                        </span>
                      </div>

                      <div className="d-flex align-items-center mb-2">
                        {res.status === "completed" ? (
                          <span className="badge bg-success p-1 mx-2" style={{ width: "70px", fontWeight: "bold", fontSize: "0.75rem" }}>
                            Paid
                          </span>
                        ) : res.status === "partial" ? (
                          <span className="badge bg-warning text-dark p-1 mx-2" style={{ width: "100px", fontWeight: "bold", fontSize: "0.75rem" }}>
                            Partial
                          </span>
                        ) : (
                          <span className="badge bg-danger p-1 mx-2" style={{ width: "70px", fontWeight: "bold", fontSize: "0.75rem" }}>
                            Unpaid
                          </span>
                        )}

                        <Button
                          variant="outline-primary"
                          size="sm"
                          onClick={() => handleDownloadReceipt(res)}
                          title="Download Receipt"
                        >
                          <FiDownload />
                        </Button>

                        {receiptData && (
                          <div style={{ display: "none" }}>
                            <FeeReceipt
                              ref={receiptRef}
                              receiptData={receiptData}
                            />
                          </div>
                        )}

                        <span
                          onClick={() => toggleDetails(res.id)}
                          style={{ cursor: "pointer", marginLeft: "10px" }}
                        >
                          {openItem === res.id ? (
                            <i
                              class="fa fa-chevron-up"
                              style={{ fontSize: "18px" }}
                            ></i>
                          ) : (
                            <i
                              class="fa fa-chevron-down"
                              style={{ fontSize: "18px" }}
                            ></i>
                          )}
                        </span>
                      </div>
                    </div>

                    {openItem === res.id && (
                      <div className="mt-3">
                        <Row className="mb-2">
                          <Col lg={10} className="text-left">
                            Due Date
                          </Col>
                          <Col lg={2} className="text-right">
                            {res.due_date}
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col lg={10} className="text-left">
                            Paid Date
                          </Col>
                          <Col lg={2} className="text-right">
                            {res.payment_date}
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col lg={10} className="text-left">
                            Receipt Number
                          </Col>
                          <Col lg={2} className="text-right">
                            {res.receipt_number}
                          </Col>
                        </Row>
                      </div>
                    )}
                  </Card.Body>
                </Card>
              );
            })
          ) : (
            <Card className="align-item-center mx-4">
              <span>No record found</span>
            </Card>
          )}
        </Col>
      </Row>
    </>
  );
};

export default FeeDepositeEdit;